<template>
  <v-container fluid>
    <v-row class="text-center" justify="center">
      <v-col cols="12" sm="8" md="7">
        <v-card
            class="elevation-12"
            max-width="800"
            min-width="400">
          <v-toolbar dark color="primary">
            <v-col>
              <v-toolbar-title>
                {{ $t('Реестр банковских реквизитов пользователей') }}
              </v-toolbar-title>
            </v-col>
          </v-toolbar>
          <v-card-text>
            <v-progress-linear
                height="5"
                class="mb-3"
                :active="isLoading"
                color="blue"
                indeterminate />
            <general-error v-if="!!generalError" />
            <ValidationObserver ref="report" @keydown.native.enter="focusOnBtn('getReportBtn')">
              <validatable-mail-list
                  v-model="emails"
                  :label="$t('Список получателей отчета')" />
            </ValidationObserver>
          </v-card-text>
          <v-row>
            <v-col>
              <v-btn
                  id="getReportBtn"
                  ref="getReportBtn"
                  v-test="{ btn: 'getReport' }"
                  color="primary"
                  :disabled="isLoading"
                  @click.stop="getBankAccountsReport">
                {{ $t('Получить отчет') }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
  import GeneralError from '../../../reused/common/GeneralError.vue'
  import ValidatableMailList from '../../../reused/ui/ValidatableMailList.vue'
  import { mapActions } from 'vuex'
  import { REPORTS } from '@/constants/store.js'

  export default {
    components: {
      GeneralError,
      ValidatableMailList
    },
    data () {
      return {
        isLoading: false,
        emails: []
      }
    },
    methods: {
      ...mapActions(REPORTS.NAMESPACE, {
        getBankAccountsReportAction: REPORTS.ACTIONS.GET_BANK_ACCOUNTS_REPORT
      }),
      getBankAccountsReport: async function () {
        try {
          this.isLoading = true
          await this.getBankAccountsReportAction({ emails: this.emails })
        } catch (error) {
          this.throwIfNotServerError(error)
        } finally {
          this.isLoading = false
        }
      }
    }
  }
</script>
